import React from 'react';
import ViewLog from './ViewLog';

// V3 reskin: page renders its own glass hero, so the legacy Breadcrumbs
// strip + Bootstrap Container wrapper are dropped.
const Log = () => <ViewLog />;

export default Log;
